import {
  createFileRoute,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';
import { BaseLayout } from '@/components';
import { UserForm } from '@/components/forms/user-form';
import { FORM_MODES } from '@/constants/form.constants';
import ROLES from '@/constants/roles.constants';
import { useAuth } from '@/hooks/use-auth';

export const Route = createFileRoute('/organizations/add/')({
  component: AddUser,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      account: (search.account as string) || undefined,
    };
  },
});

function AddUser() {
  const navigate = useNavigate();
  const { account } = useSearch({ from: '/organizations/add/' });
  const { user } = useAuth();
  const isDriverLabel =
    user?.role === ROLES.EXECUTIVE || user?.role === ROLES.MANAGER;
  const pageTitle = isDriverLabel ? 'Add Driver' : 'Add User';

  const handleSuccess = (accountUuid?: string) => {
    navigate({ to: '/organizations', search: { account: accountUuid } });
  };

  const handleCancel = () => {
    if (account) {
      navigate({
        to: '/accounts/$uuid',
        params: { uuid: account },
        search: { tab: 'overview' },
      });
    } else {
      navigate({ to: '/organizations' });
    }
  };

  return (
    <BaseLayout
      header={{
        headerText: pageTitle,
      }}
      breadcrumbs={{
        showBreadcrumbs: true,
        breadcrumbText: [pageTitle],
      }}
    >
      <UserForm
        mode={FORM_MODES.ADD}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        defaultAccountUuid={account}
      />
    </BaseLayout>
  );
}
